import { render, staticRenderFns } from "./ReliabilityPage.vue?vue&type=template&id=9a917e20&scoped=true&"
import script from "./ReliabilityPage.vue?vue&type=script&lang=js&"
export * from "./ReliabilityPage.vue?vue&type=script&lang=js&"
import style0 from "./ReliabilityPage.vue?vue&type=style&index=0&id=9a917e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a917e20",
  null
  
)

export default component.exports